export const APP_CONFIG = {
  app: 'JPerfectSolution',
  appName: 'JPerfectSolution',
  logo: 'assets/logo/logo.png',
  version: '1.0.0',
  copyright: '2017 © JPerfectSolution',
};
